import { Constants } from "./Constants";

export class Utilities {
    /**
     * Prüft einen Parameter auf einen Funktionsausdruck
     * -> https://api.jquery.com/jQuery.isFunction/
     * @param value möglicher Funktionsausdruck
     * @returns true, wenn value eine Funktion ist
     */
    public static isFunction(value: any): boolean {
        return typeof value === 'function';
    }

    /**
     * Ersetzt HTML-Sonderzeichen. Verhält sich analog zur Underscore-Methode "escape"
     * Zusätzlich wird die Raute ersetzt
     * @param str Der zu maskierende String
     * @return escaped String
     */
     public static escape(str: string){
        let escapedString = str;
        escapedString = escapedString.replace('&', '&amp;');
        escapedString = escapedString.replace('#', '&num;');
        escapedString = escapedString.replace('<', '&lt;');
        escapedString = escapedString.replace('>', '&gt;');
        escapedString = escapedString.replace('"', '&quot;');
        escapedString = escapedString.replace('`', '&#96;');
        escapedString = escapedString.replace('\'', '&#x27;');

        return escapedString;
    }

    /**
     * Berechnet den Durchschnittswert eines Arrays ohne vorhandene nullen zu betrachten
     * @param arr 
     * @returns 
     */
    public static average(arr: Array<any>): number {
        let sum = 0;
        let division = 0;
        let max = 0;
        if (arr.length === 0) {
            return 0;
        }

        for (let i = 0; i < arr.length; i++) {
            let entry = arr[i];
            if (!(entry == 0))  {
                sum += entry;
                division++;
            }

            if(entry > max) {
                max = entry;
            }
        }

        let divisor = division != 0 ? division : arr.length;
        var average = sum / divisor;

        if(average < Constants.MIN_COLUMN_WIDTH)
            average = Constants.MIN_COLUMN_WIDTH;

        //Wenn der Average nur 20% kleiner als MAX ist, dann nehme MAX
        //Wenn die Differenz zwischen Average und Max kleiner 40px ist, dann kann auch Max genommen werden
        if((average * 1.20) > max || (max - average) < 40)
            return max;

        return average;
    }

    /**
     * Bestimmt den maximalen Wert innerhalb des uebergebenen Arrays
     * @param arr Array mit numerischen Werten
     * @returns max-Wert innerhalb des Array
     */
    public static max(arr: Array<number>): number {
        let max = arr[0];
        
        for (let i = 1; i < arr.length; i++) {
            if (arr[i] > max)
                max = arr[i];
        }

        return max;
    }

    /**
     * Bestimmt die Summe aller Eintraege innerhalb des uebergebenen Arrays
     * @param arr Array mit numerischen Werten
     * @returns Summe aller Eintraege im Array
     */
    public static sum(arr: Array<number>): number {
        let sum = 0;
        for (let i = 0; i < arr.length; i++) 
            sum += arr[i];

        return sum;
    }

    /**
     * Prüft ob ein Wert größer oder gleich dem anderen ist
     * @param value1 
     * @param value2 
     * @returns 
     */
    public static isLargerOrEqual(value1: string | number, value2: string | number){
        return parseInt(value1 as string) >= parseInt(value2 as string);
    }

    /**
     * Entfernt Angaben wie 'px' und '%' aus width-strings
     * @param value 
     * @returns 
     */
    public static getWidthAsNumber(value: any): number {
        if (value) {
            return parseInt(value.toString().replace('px', '').replace('%', '').trim());
        } else {
            return 0;
        }
    }

    public static isNullOrEmpty(value: string): boolean {
        return value === undefined || value === null || value === '';
    }

    public static debounce<P extends any[]>(callback: (...args: P) => void, waitMS: number): (...args: P) => void {
        let timeoutId: number = null;
        return (...args: P) => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => {
                callback(...args);
            }, waitMS);
        };
    }

    public static waitForDomAppearance(selector: string): Promise<Element> {
        return new Promise((resolve) => {
            if (document.querySelector(selector))
                resolve(document.querySelector(selector));

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    public static getRandomIdentifier(): string {
        return Math.random().toString(36).substring(2, 10)
    }
}